export const handleSubmitForm = (values, mutateUpload, dataBarcode, dataWarrantyCode) => {
  // ถ้าในช่องรหัสรับประกันมีค่า ไม่ตรงกันกับรหัสที่ validate จาก API จะ throw error
  if(values.warrantyNumberCode && values.warrantyNumberCode != dataWarrantyCode?.warranty?.warrantyNumberCode){
    throw new Error('รหัสรับประกันไม่ตรงกัน กรุณาตรวจสอบรหัสรับประกันก่อน (Enter รหัสรับประกัน)');
  }
  const uploadData = {
    invImage: values.invImage ? values.invImage[0] : null,
    packageImage: values.packageImage ? values.packageImage[0] : null,
    telephone: values.telephone,
    fullName: values.fullName,
    mobileBrandId: values.mobileBrandId,
    mobileModelName: values.mobileModelName,
    productId: dataBarcode.item.productId,
    warrantyNumberCode: values.warrantyNumberCode,
    channelBuyId: values.channelBuyId,
    purchaseDate: values.purchaseDate,
  };
  mutateUpload(uploadData);
};
